// extracted by mini-css-extract-plugin
module.exports = {"text":"BigFiveTestCongrats_text__2mBB2"};